module.exports = __webpack_public_path__ + "static/media/Phone_Icon2-01.2a908f82.svg";